import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../../supabaseClient";
import { Box, TextField, Button, Typography } from "@mui/material";

export default function ResetPassword() {
	const [password, setPassword] = useState("");
	const [status, setStatus] = useState("");
	const navigate = useNavigate();

	useEffect(() => {
		// On mount, check for access_token in URL hash and set session
		const hash = window.location.hash;
		if (hash.includes("access_token")) {
			supabase.auth.setSession({
				access_token: new URLSearchParams(hash.substring(1)).get(
					"access_token"
				),
				refresh_token: new URLSearchParams(hash.substring(1)).get(
					"refresh_token"
				),
			});
		}
	}, []);

	const handleReset = async () => {
		const { error } = await supabase.auth.updateUser({ password });
		if (error) {
			setStatus(error.message);
		} else {
			setStatus("Password updated! You can now log in.");
			setTimeout(() => navigate("/login"), 2000);
		}
	};

	return (
		<Box sx={{ maxWidth: 400, mx: "auto", mt: 8 }}>
			<Typography variant="h5" mb={2}>
				Reset Password
			</Typography>
			<TextField
				label="New Password"
				type="password"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				fullWidth
				sx={{ mb: 2 }}
			/>
			<Button variant="contained" fullWidth onClick={handleReset}>
				Set New Password
			</Button>
			{status && <Typography mt={2}>{status}</Typography>}
		</Box>
	);
}
